import About from './about'
import Callback from './callback'
import DrawerOption from './DrawerOption'
import Graph from './Graph'
import Home from './home'
import Legal from './legal'
import PendingRegistration from './PendingRegistration'
import Plain from './plain'
import QueryEdit from './QueryEdit'
import TreeViewGraph from './TreeViewGraph'

export {
  About,
  Callback,
  DrawerOption,
  Graph,
  Home,
  Legal,
  PendingRegistration,
  Plain,
  QueryEdit,
  TreeViewGraph
}



// WEBPACK FOOTER //
// ./src/components/index.js